import { UsernameRuleTypes } from '../types';

class UsernameRule {
  ruleType: UsernameRuleTypes;
  value: number | string;

  constructor(ruleType: UsernameRuleTypes, value: string) {
    this.ruleType = ruleType;
    if (value && value.match(/^[0-9]*$/)) {
      this.value = Number(value);
    } else {
      this.value = value;
    }
  }
}

export { UsernameRule };
